import { resetDockingOnboarding } from "@/features/mix-onboarding/lib/dockingOnboarding";
import { resetR18BlurOnboarding } from "@/features/r18-blur-onboarding/lib/r18BlurOnboarding";
import { removeThreadNgPresets } from "@/features/thread/stores/threadNgPresetStorage";

export interface ClearAllUserDataActions {
  clearHistory: () => void;
  clearPostedHistory: () => void;
  clearOwnPosts: () => void;
  clearAllNgSettings: () => void;
  clearAllFavSettings: () => void;
  resetCatalogSettings: () => void;
  resetSettings: () => void;
  resetMixSettings: () => void;
}

/**
 * 「全データをクリア」で全ユーザー設定ストアを初期化する。
 * 総合カタログの板構成と初回パネルの完了記録、ぼかし案内の承認記録も対象に含める。
 */
export function clearAllUserData(actions: ClearAllUserDataActions): void {
  actions.clearHistory();
  actions.clearPostedHistory();
  actions.clearOwnPosts();
  actions.clearAllNgSettings();
  removeThreadNgPresets();
  actions.clearAllFavSettings();
  actions.resetCatalogSettings();
  actions.resetSettings();
  actions.resetMixSettings();
  resetDockingOnboarding();
  resetR18BlurOnboarding();
}
